import { BaseApiService } from "../../base-api-service";
import { ApiVersions } from "../../../enums";
import { env } from "../../../environment";
import {
  BalanceLimitResponse,
  BalanceTransactionRequestData,
  CashInOrCashOutBalanceRequestData,
  GetBalanceHistoryRequest,
} from "../../../models/managerResponse";

class ManagerController extends BaseApiService {
  public async transferBalance(amount: string | number, pinCode: string | number) {
    let url = `${this.url}/api/${ApiVersions.V1}/wallet/balance-transfer`;
    return await this.http.put(url, { amount, pinCode });
  }

  public async takeBalance(amount: number | string, pinCode: number | string) {
    const url = `${this.url}/api/${ApiVersions.V1}/wallet/balance-take`;
    return await this.http.put(url, { amount, pinCode });
  }

  /////New
  public async cashOutBalance(data: CashInOrCashOutBalanceRequestData) {
    const url = `${this.url}/api/${ApiVersions.V1}/wallet/cash-out`;
    return await this.http.put(url, data);
  }

  public async cashInBalance(data: CashInOrCashOutBalanceRequestData) {
    const url = `${this.url}/api/${ApiVersions.V1}/wallet/cash-in`;
    return await this.http.put(url, data);
  }

  public async getBalanceHistory(params: GetBalanceHistoryRequest): Promise<BalanceLimitResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/wallet/balance-history`;
    return await this.http.get(url, { params });
  }

  public async getLimitHistory(params: GetBalanceHistoryRequest): Promise<BalanceLimitResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/wallet/limit-history`;
    return await this.http.get(url, { params });
  }

  public async balanceTransaction(data: BalanceTransactionRequestData): Promise<BalanceLimitResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/wallet/balance-transaction-request`;
    return await this.http.post(url, data);
  }

}

export const managerController = new ManagerController({ url: env.httpUrl });
